import { render, staticRenderFns } from "./mail-reply-other-content.vue?vue&type=template&id=0b15ea7c&scoped=true&"
import script from "./mail-reply-other-content.vue?vue&type=script&lang=js&"
export * from "./mail-reply-other-content.vue?vue&type=script&lang=js&"
import style0 from "./mail-reply-other-content.vue?vue&type=style&index=0&id=0b15ea7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15ea7c",
  null
  
)

export default component.exports